export default __webpack_public_path__ + "static/media/meta_.67d2e2ae.svg";